import {
    Controller
} from "stimulus"
import * as basicScroll from 'basicscroll'
import {doNotLazyLoad} from "../helpers";

/**
 * Controller for parallax using basicscroll.js
 */
export default class extends Controller
{
    basicScroll

    /**
     * Where should the animation start from?
     * [top|right|bottom|left of element]-[top|right|bottom|left of viewport]
     * @returns {string}
     */
    get from() {
        return this.data.has('from') ? this.data.get('from') : 'top-bottom'
    }

    /**
     * Where should the animation stop at?
     * [top|right|bottom|left of element]-[top|right|bottom|left of viewport]
     * @returns {string}
     */
    get to() {
        return this.data.has('to') ? this.data.get('to') : 'bottom-top'
    }

    /**
     * If using the default props, the name of the css variable
     * @returns {string}
     */
    get varName() {
        return this.data.has('varName') ? this.data.get('varName') : '--y'
    }

    /**
     * If using the default props, what should the y value start at?
     * @returns {string}
     */
    get fromY() {
        return this.data.has('fromY') ? this.data.get('fromY') : '5vh'
    }

    /**
     * If using the default props, what should the y value end at?
     * @returns {string}
     */
    get toY() {
        return this.data.has('toY') ? this.data.get('toY') : '-5vh'
    }

    /**
     * return the animation props
     * @returns {string}
     */
    get props() {
        if (this.data.has('props')) {
            return this.data.get('props')
        }

        let props = {}

        props[this.varName] = {
            from: this.fromY,
            to: this.toY
        }

        return props
    }

    /**
     * The basicScroll config
     * @returns {any}
     */
    get config()
    {
        return this.data.has('config') ? this.data.get('config') : {
            elem: this.element,
            from: this.from,
            to: this.to,
            props: this.props,
            direct: true
        }
    }

    /**
     * It's in the dom
     */
    connect()
    {
        this.element.querySelectorAll('img').forEach(doNotLazyLoad)
        this.initBasicScroll()
    }

    /**
     * Create and start basicscroll
     */
    initBasicScroll()
    {
        this.basicScroll = basicScroll.create(this.config)
        this.basicScroll.start()
    }

    /**
     * Destroy basic scroll
     */
    destroyBasicScroll() {
        this.basicScroll.destroy()
    }

    /**
     * It's removed from the dom.
     */
    disconnect() {
        this.destroyBasicScroll()
    }
}
